// extracted by mini-css-extract-plugin
export default {"tit-law":"Header_tit-law__RzUnT","img-tit":"Header_img-tit__ZA4YC","img-txt":"Header_img-txt__Qrgsb","txt-desc":"Header_txt-desc__5USD6","tit-desc":"Header_tit-desc__4bv-B"};